import {http} from './config/config-relation-register'

export default{
    listar:(token)=>{
        return  http.get('tipos-produto',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, produto)=>{
        return http.post('tipos-produto',produto,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('tipos-produto/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, produto)=>{
        return http.put('tipos-produto/'+produto.id_tipo_produto,produto,{
            headers:{
                'Authorization':token
            }
        })
    }

}